import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, normalizeClass as _normalizeClass } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  class: /*#__PURE__*/_normalizeClass(`rad5 w100 pad10 hoverLgreyBg`)
}
const _hoisted_3 = {
  class: /*#__PURE__*/_normalizeClass(``),
  style: ``
}
const _hoisted_4 = {
  class: "fs14 fw600",
  style: {}
}
const _hoisted_5 = { class: "" }
const _hoisted_6 = { class: "fs12" }
const _hoisted_7 = {
  key: 0,
  class: "lgreyBg fs12 pad5 ml5 rad5"
}
const _hoisted_8 = ["src"]
const _hoisted_9 = { class: "arial" }
const _hoisted_10 = {
  key: 1,
  class: "label gradBlueBg"
}
const _hoisted_11 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_12 = { key: 0 }
const _hoisted_13 = /*#__PURE__*/_createElementVNode("br", null, null, -1)
const _hoisted_14 = { class: "arial fs18" }
const _hoisted_15 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_16 = {
  class: "mc centered mt10",
  style: {"width":"170px"}
}
const _hoisted_17 = ["src"]
const _hoisted_18 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)
const _hoisted_19 = /*#__PURE__*/_createElementVNode("div", { class: "clear" }, null, -1)

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _directive_tooltip = _resolveDirective("tooltip")!

  return (_ctx.room)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", _hoisted_5, [
                _createElementVNode("div", null, [
                  _createElementVNode("span", _hoisted_6, _toDisplayString(_ctx.title), 1),
                  (_ctx.appo)
                    ? (_openBlock(), _createElementBlock("span", _hoisted_7, [
                        _createElementVNode("img", {
                          src: _ctx.$getAssetImageUrl(`/assets/icons/watch2.png`),
                          width: "14",
                          height: "14",
                          class: "ml2"
                        }, null, 8, _hoisted_8),
                        _createElementVNode("span", _hoisted_9, _toDisplayString(_ctx.appo.duration) + "分 ", 1)
                      ]))
                    : _createCommentVNode("", true),
                  (_ctx.rs && _ctx.rs.is_instant_room)
                    ? (_openBlock(), _createElementBlock("label", _hoisted_10, "スグIN"))
                    : _createCommentVNode("", true)
                ]),
                _hoisted_11,
                (_ctx.formMem)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_12, _toDisplayString(_ctx.formMem.name) + "様", 1))
                  : _createCommentVNode("", true),
                _hoisted_13,
                _createElementVNode("span", _hoisted_14, _toDisplayString(_ctx.fixTime), 1)
              ])
            ]),
            _hoisted_15,
            _createElementVNode("div", _hoisted_16, [
              (_ctx.formMem)
                ? _withDirectives((_openBlock(), _createElementBlock("div", {
                    key: 0,
                    class: "rad8 pointer centered circle_button blueAround fs16 fl",
                    style: {"padding":"8px 14px","width":"56px"},
                    onClick: _cache[0] || (_cache[0] = 
//@ts-ignore
(...args) => (_ctx.clickFormMember && _ctx.clickFormMember(...args)))
                  }, [
                    _createElementVNode("img", {
                      src: _ctx.$getAssetImageUrl(`/assets/icons/form_icon.png`),
                      width: "24",
                      height: "24",
                      style: {}
                    }, null, 8, _hoisted_17)
                  ])), [
                    [_directive_tooltip, `フォーム確認`]
                  ])
                : _createCommentVNode("", true),
              (_ctx.room.room_type == `parent_room`)
                ? (_openBlock(), _createElementBlock("label", {
                    key: 1,
                    class: _normalizeClass(`circle_button fw600 fr centered fs12 blueAround hoverSkyblueBg`),
                    style: {"width":"110px","padding":"4px 10px"},
                    onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.goRoom && _ctx.goRoom(...args)))
                  }, " 調整ページへ "))
                : _createCommentVNode("", true)
            ]),
            _hoisted_18
          ])
        ]),
        _hoisted_19
      ]))
    : _createCommentVNode("", true)
}